import React, { useEffect, useState } from "react";

const AqiDisplay = (props) => {
  const [AqiColor, setAqiColor] = useState();

  const setTheColorOfAqi = () => {
    if (props.AQI > 0 && props.AQI <= 50) {
      setAqiColor("#0f9d63");
    } else if (props.AQI > 50 && props.AQI <= 100) {
      setAqiColor("#ffd700");
    } else if (props.AQI > 100 && props.AQI <= 150) {
      setAqiColor("#ff8c00");
    } else if (props.AQI > 150 && props.AQI <= 200) {
      setAqiColor("#ff0000");
    } else if (props.AQI > 200 && props.AQI <= 300) {
      setAqiColor("#800080");
    } else if (props.AQI > 300) {
      setAqiColor("#a52a2a");
    } else {
      setAqiColor("#8f8f8f");
    }
  };

  useEffect(() => {
    setTheColorOfAqi();
  }, [props.AQI]);

  return (
    <div
      style={{ backgroundColor: AqiColor }}
      className="d-flex justify-content-center align-items-center py-2 px-3 IransansXE"
    >
      <h6 className="m-0">{props.AQI}</h6>
    </div>
  );
};
export default AqiDisplay;
